import { useEffect, useRef, useState } from "react";
import fav from "../assets/new-images/favicon.png";
const ProofBlock = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpen(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isPopupOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [isPopupOpen]);

  return (
    <>
      {isPopupOpen && (
        <div
          className="fixed left-0 top-0 w-[100vw] h-[100vh] overflow-auto z-[999]"
          style={{ backdropFilter: "blur(2px)", background: "#8f8f8f33;" }}
        ></div>
      )}

      <div className="proof-block relative" ref={popupRef}>
        <div className="edu-block">
          {/* <div className="text mb-5">
            Are you a <b>Professional or an Educator?</b>
          </div> */}
          {/* <div className="edu-offer-btn" onClick={() => setIsPopupOpen(true)}>
            Get special offer.
          </div> */}
        </div>
        <div className="awards-list">
          <div className="item">
            <i className="icon fa fa-briefcase"></i>
            Work. Simplified.
            <span>Smarter tasks. Fewer clicks.</span>
          </div>
          <div className="item">
            <i className="icon fa fa-globe"></i>
            Made in India.
            <span>Global by design.</span>
          </div>
          <div className="item">
            <i className="icon fa fa-layer-group"></i>
            All-in-One.
            <span>Files, chats, tasks — together.</span>
          </div>
        </div>
        {isPopupOpen && (
          <div
            className="fixed z-[1119] min-w-[280px] max-w-[1000px] rounded-lg bg-white border border-1 top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2"
            style={{ boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.1)" }}
          >
            <div className="max-w-[1000px] md:w-[600px] lg:w-[900px] min-w-[300px] px-[15px] py-[40px] flex flex-col gap-3">
              <div className="mb-5 mt-5">
                <img src={fav} alt="" className="my-0 mx-auto h-[60px] mb-5" />
                <div className="text-2xl font-bold">
                  Verify your email to Get Special Offer
                </div>
              </div>
              <div className="flex flex-col max-w-[500px] mx-auto my-0 min-w-[200px] sm:w-[400px]">
                <input
                  type="text"
                  className="border border-1 rounded-lg mb-5 px-3 py-2 focus:ring-2 focus:outline-none"
                  placeholder="Enter Email"
                />
                <input
                  type="text"
                  className="border border-1 rounded-lg px-3 py-2 mb-5 focus:ring-2 focus:outline-none"
                  placeholder="Enter Organization name"
                />
              </div>
              <div className="custom-header-btn login-btn rounded-xl py-1 custom-padding max-w-[500px] mx-auto my-0 min-w-[200px] sm:w-[400px]">
                Submit
              </div>
              <div>
                By clicking submit, You confirm that you have read the Privacy
                Policy
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProofBlock;
